import themeVariables from "@/config/theme/themeVariable";
import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useSearchParams, useRouter } from "next/navigation";
import { useEffect } from "react";

interface CareModalProps {
  forceOpened?: boolean;
  onClose?: () => void;
}

export const CareModal = ({ forceOpened = false, onClose }: CareModalProps) => {
  const [opened, { open, close }] = useDisclosure(forceOpened);
  const searchParams = useSearchParams();
  const router = useRouter();
  
  useEffect(() => {
    if (searchParams?.get('modal') === 'care' || forceOpened) {
      open();
    }
  }, [searchParams, open, forceOpened]);

  const careTypes = [
    { 
      id: 'surgery', 
      label: '수술', 
      url: '/surgery/care'
    },
    { 
      id: 'meal', 
      label: '식사', 
      url: '/meal/care'
    },
    { 
      id: 'nutrition', 
      label: '영양분', 
      url: '/nutrition/care'
    },
    { 
      id: 'swelling', 
      label: '붓기', 
      url: '/swelling/care'
    }
  ];
  
  const handleCareTypeClick = (url: string) => {
    close();
    if (onClose) onClose();
    router.push(url);
  };
  
  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          close();
          if (onClose) onClose();
        }}
        withCloseButton={false}
        centered
        radius={'lg'}
        padding={24}
        size='lg'
        closeOnClickOutside={true}
        classNames={{ 
        content: 'scrollbar-hide', 
        }}
      >
        <div className="flex flex-col gap-2 mb-6">
          <div className="text-lg text-gray-700 dark:text-gray-100 font-semibold" data-autofocus>
            수술 후 케어법
          </div>
          <p className="text-[15px] text-gray-700 dark:text-gray-100 font-normal">
            수술 종류별 회복 기간, 관리 방법, 주의사항, 그리고 일상 생활 복귀 가이드를 확인하세요.
          </p>
        </div>
        
        <div className="mt-6 mb-8 animate-fadeIn">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-[560px] mx-auto">
            {careTypes.map((type) => (
              <div
                key={type.id}
                className="flex flex-col items-center justify-center gap-3 border border-gray-200 dark:border-gray-700 p-4 text-center h-[76px] text-gray-700 text-[15px] font-normal hover:border-blue-700 hover:text-blue-700 dark:hover:text-blue-400 transition-colors cursor-pointer rounded-lg bg-white dark:bg-gray-800"
                onClick={() => handleCareTypeClick(type.url)}
              >
                <div className="text-[15px] font-normal">{type.label}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="flex gap-1 justify-end mt-5">
          <Button 
            classNames={themeVariables.button.gray} 
            onClick={() => {
              close();
              if (onClose) onClose();
            }}
          >
            닫기
          </Button>
        </div>
      </Modal>
    </>
  )
}